
import minifyTheme from 'minify-css-string'

export default {
    icons: false,
    theme: {
      disable: true,
      options: {
        minifyTheme,
        themeCache: {
          get: key => localStorage.getItem(key),
          set: (key, value) => localStorage.setItem(key, value),
        },
      },
    },
}